import script from "./NotificationsFromTeachersSubpage.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotificationsFromTeachersSubpage.vue?vue&type=script&setup=true&lang=ts"

import "./NotificationsFromTeachersSubpage.vue?vue&type=style&index=0&id=44bb8194&scoped=true&lang=scss"

import exportComponent from "/builds/snedson/snotra-backend/snotra-front-ts/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44bb8194"]])

export default __exports__